export * from './src/app/angular2-multiselect-dropdown/multiselect.component';


// WEBPACK FOOTER //
// /app/~/angular2-multiselect-checkbox-dropdown/angular2-multiselect-dropdown.ts